import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const WriteOffSchema = yup.object({
  amount: yup.string().required("Amount is required"),
  writeOffAt: yup
    .date()
    .typeError("Write-off date must be a valid date")
    .required("Write-off date is required"),
});

const Validation = (details) => {
  return useForm({
    resolver: yupResolver(WriteOffSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      amount: details?.amount ?? "",
      writeOffAt: details?.write_of_at ?? "",
    },
  });
};

export default Validation;
